import React from 'react';
import PropTypes from 'prop-types';
import { iconConfigs } from '../constants';
import {
    useSsSelector as useSelector,
} from '~SpectateStore';

import {
    selectHasOddsBoost,
} from '~Betslip/selectors/selectionDetailsSelectors';

import classNames from 'classnames';
import './styles.scss';

const BetDescriptionIcons = ({ selectionId }) => {
    const isOddsBoost = useSelector((state) => selectHasOddsBoost(state, selectionId));

    if (!isOddsBoost) {
        return null;
    }

    const iconList = {
        showOddsBoostBanner: isOddsBoost,
    };

    const selectionBannerClass = classNames('babyslip__selection-description', {
        'babyslip__selection-description-odds-boost': isOddsBoost,
    });

    const bannerIconClass = 'babyslip__description-icon';

    const icons = iconConfigs
        .filter(({conditionKey}) => iconList[conditionKey])
        .map(({conditionKey, iconClass}) => {

            return (
                <li
                    key={conditionKey}
                    className={selectionBannerClass}
                >
                    <span className={classNames(iconClass, bannerIconClass)}>
                    </span>
                </li>
            );
        });

    return icons.length
        ? <ul className="babyslip__descriptions">
            { icons }
        </ul>
        : null;

};

BetDescriptionIcons.propTypes = {
    selectionId: PropTypes.string.isRequired,
};

export default BetDescriptionIcons;
